import React from 'react';

const ResourceInfoPopup = ({ resource }) => {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-4 rounded-lg shadow-lg z-50">
      <h3 className="text-lg font-bold mb-2">{resource.name}</h3>
      <p className="mb-2">Type: {resource.type}</p>
      {resource.skills && (
        <div>
          <p className="font-semibold">Skills:</p>
          <ul className="list-disc list-inside">
            {resource.skills.map((skill, index) => (
              <li key={index}>{skill}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ResourceInfoPopup;
